import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../../commonComponents/AddBtn'
import { FormTitle } from '../../../../commonComponents/FormTitle'
import List from '../../../../commonComponents/List'
import { CustomLoader } from '../../../../commonComponents/formComponents/loader'
import { TranslateContext } from '../../TranslateContext'
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType'
import { useMultipleMerchandiseItem } from '../../../hooks/useMultipleMerchandiseItem'
import AdditionalInfoForm from './addtionalInfoForm'

const AdditionalInfo = ({ merchandiseId, invoiceId, invoiceIndex, lineItemIndex }) => {
  const key = 'additionalInfo'
  const { isDMS } = useCurrentShipmentType()
  const dispatch = useDispatch()

  const additionalInfoList =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.additionalInfo) || []
  const {isLoading,AddItem,deleteItem,updateItem,saveItem, copyData}=useMultipleMerchandiseItem({tableName:key,invoiceId,merchandiseId});

  const renderItem = useCallback(
    (item) => {
      return (
        <AdditionalInfoForm
          key={item.id}
          item={item}
          updateData={updateItem}
          deleteData={deleteItem}
          saveData={saveItem}
          copyData={copyData}
          invoiceIndex={invoiceIndex}
          lineItemIndex={lineItemIndex}
        />
      )
    },
    [updateItem, deleteItem,saveItem,copyData]
  )

  const translate = React.useContext(TranslateContext).translate

  return (
    <Form.Group className='float-container mb-2'>
      <FormTitle
        boxNumber={isDMS ? '2/2' : ''}
        title={translate('ADDITIONAL_INFORMATION')}
      ></FormTitle>
      <List dataSource={additionalInfoList}  renderItem={renderItem} />

      {isLoading && <CustomLoader />}
      {additionalInfoList?.length < 99 && (
        <AddBtn
          id={`add-additionalInfo-${invoiceId}-${merchandiseId}`}
          onClick={AddItem}
          text={translate('ADD')}
        ></AddBtn>
      )} 
    </Form.Group>
  )
}

export default React.memo(AdditionalInfo)
